module.exports = __webpack_public_path__ + "e232f6440323dd671f5506447aa9d09d.MP3";